import { MapPin, Clock } from "lucide-react";
import { useApi } from "../lib/api";
import { PageHeader, Loading, Empty, Badge } from "../components/common";
import { fmtDate, todayISO } from "../lib/format";

const ShiftCard = ({ a, tone }) => (
  <div className="surface p-4" data-testid={`shift-${a.id}`}>
    <div className="flex justify-between gap-2"><div className="font-semibold text-lg font-heading">{a.site_name}</div>{tone}</div>
    <div className="text-sm text-muted-foreground mt-1 flex items-center gap-1.5"><Clock className="h-4 w-4" />{a.shift} · {a.hours_per_day} h/giorno</div>
    <div className="num text-sm mt-2">{fmtDate(a.start_date)} → {fmtDate(a.end_date)}</div>
  </div>
);

export default function MyShifts() {
  const { data, loading } = useApi("/assignments");
  const today = todayISO();
  if (loading && !data) return <Loading />;
  const upcoming = data.items.filter((a) => a.end_date >= today);
  const past = data.items.filter((a) => a.end_date < today).reverse();
  return (
    <div className="max-w-3xl">
      <PageHeader eyebrow="Operaio" title="I miei turni" subtitle="Turni in corso, programmati e storico presenze" />
      <h2 className="eyebrow mb-3 flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />In corso e programmati</h2>
      {!upcoming.length ? <Empty title="Nessun turno programmato" /> : (
        <div className="space-y-3 mb-8">{upcoming.map((a) => <ShiftCard key={a.id} a={a} tone={a.start_date <= today ? <Badge className="bg-emerald-950 border-emerald-500 text-emerald-200">Oggi</Badge> : <Badge className="bg-sky-950 border-sky-500 text-sky-200">Programmato</Badge>} />)}</div>
      )}
      <h2 className="eyebrow mb-3">Storico presenze</h2>
      {!past.length ? <Empty title="Nessuno storico" /> : <div className="space-y-3">{past.map((a) => <ShiftCard key={a.id} a={a} tone={<Badge className="bg-slate-800 border-slate-600 text-slate-300">Concluso</Badge>} />)}</div>}
    </div>
  );
}
